import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=opening&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '重新定义国宾馆',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        description: `当前多数国宾馆面临着服务理念滞后、设施陈旧、市场化运作能力薄弱等痛点。华美帮助国宾馆业主在保留政务接待核心功能的基础上，实现运营模式和商业价值的全面升级。通过重新规划空间功能，植入智能管理系统，打造兼具政务保障与商业价值的现代化国宾馆。`,
        icons: [
            {
                name: '重新定义国宾馆',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/7.重新定义国宾馆.pdf'),
                path: "四库赋能-酒店建设/重新定义国宾馆/重新定义国宾馆"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店+/重新定义国宾馆/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/重新定义国宾馆/数据赋能'),
                path: "四库赋能-酒店+/重新定义国宾馆/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/重新定义国宾馆/全球案例/全球案例（重新定义国宾馆）.xlsx'),
                path: "四库赋能-酒店建设/重新定义国宾馆/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/重新定义国宾馆/预警问题/预警问题（重新定义国宾馆）.pdf'),
                path: "四库赋能-酒店建设/重新定义国宾馆/预警问题"
            },
        ]
    }]
}